var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 70,
    viewBox: "0 0 241 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.531 61.3943C60.9458 56.3363 24.4584 33.4103 0 0.0078125C28.665 34.0914 71.7728 55.7754 119.979 55.7754V69.9978C116.373 65.1902 112.747 62.6362 102.531 61.3943Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.416 61.3943C179.002 56.3363 215.489 33.4103 239.947 0.0078125C211.282 34.0914 168.175 55.7754 119.969 55.7754V69.9978C123.574 65.1902 127.2 62.6362 137.416 61.3943Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.567 61.3865C179.152 56.3285 215.639 33.4025 240.098 0C211.433 34.0836 168.325 55.7676 120.119 55.7676V69.99C123.725 65.1824 127.351 62.6284 137.567 61.3865Z",
    fill: "url(#paint0_linear_318_3364)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.672 61.3865C61.0764 56.3285 24.589 33.4025 0.140625 0C28.8057 34.0836 71.9134 55.7676 120.119 55.7676V69.99C116.513 65.1824 112.888 62.6284 102.672 61.3865Z",
    fill: "url(#paint1_linear_318_3364)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.119 55.7676C168.325 55.7676 211.433 34.0836 240.098 0C211.853 36.0366 168.605 59.1029 120.119 59.1029C71.633 59.1029 28.385 36.0366 0.140625 0C28.8057 34.0836 71.9134 55.7676 120.119 55.7676Z",
    fill: "url(#paint2_linear_318_3364)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.855 26.3594C154.452 70.6089 82.058 68.105 27.4121 27.1807C82.3384 71.2099 159.289 70.8293 213.855 26.3594Z",
    fill: "url(#paint3_radial_318_3364)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_3364",
    x1: 240.088,
    y1: 34.995,
    x2: 120.109,
    y2: 34.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_3364",
    x1: 120.109,
    y1: 34.995,
    x2: 0.130606,
    y2: 34.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#232851"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_3364",
    x1: 240.088,
    y1: 29.5564,
    x2: 0.130613,
    y2: 29.5564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_318_3364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.629 43.1558) rotate(180) scale(66.9752)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7987AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/scroll-down.fbc8ec2cb71792586a6f93adfcfce5fb.svg";
export { ForwardRef as ReactComponent };